<template>
  <div>
    <div>メニュー管理</div>
    <v-card class="mt-4">
      <v-data-table :headers="headers" :items="items" hide-actions>
        <template v-slot:items="props">
          <tr style="border: 1px solid rgba(0,0,0,.02) !important;">
            <td class="text-xs-left no-wrap">
              <span :class="{ disabled: !props.item.isInDateRange }">
                {{ props.item.name }}
              </span>
            </td>
            <td class="text-xs-left no-wrap">
              <span :class="{ disabled: !props.item.isInDateRange }">
                {{ props.item.unitType }}
              </span>
            </td>
            <td class="text-xs-left no-wrap">
              <span :class="{ disabled: !props.item.isInDateRange }">
                {{ props.item.unitPrice }}
              </span>
            </td>
            <td class="text-xs-left no-wrap">
              <span :class="{ disabled: !props.item.isInDateRange }">
                {{ props.item.resourceRangeText }}
              </span>
            </td>
            <td class="text-xs-left no-wrap">
              <span :class="{ disabled: !props.item.isInDateRange }">
                {{ props.item.dateRange }}
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="6">
              <span
                class="pl-4"
                :class="props.item.isInDateRange ? 'description' : 'disabled'"
              >
                {{ props.item.description }}
              </span>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <div>登録されているメニューはありません</div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import JAPANESE from '@/constants/japanese'

export default {
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        // { text: JAPANESE.actions, value: 'actions', sortable: false },
        { text: JAPANESE.menuName, value: 'name' },
        { text: JAPANESE.unitType, value: 'unitType' },
        { text: JAPANESE.unitPrice, value: 'unitPrice' },
        { text: JAPANESE.resourceType, value: 'resource' },
        { text: JAPANESE.resourceDateRange, value: 'dateRange' },
      ],
    }
  },
}
</script>

<style scoped>
.v-data-table {
  min-width: 100%;
}
/*v-chipも実体はspanなので適用される*/
span.disabled {
  opacity: 0.25;
}
span.description {
  opacity: 0.5;
}
</style>
